import { render, staticRenderFns } from "./CuttingEdge.vue?vue&type=template&id=5f6f9596"
import script from "./CuttingEdge.vue?vue&type=script&lang=js"
export * from "./CuttingEdge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports